// import { RedoOutlined } from "@ant-design/icons";
import { useStorageActions } from "../../context/storageContext";
import playAgain from "../../assets/play_again.png";
import playAgainHover from "../../assets/play_againHover.png";
import bgResult from "../../assets/bg_result.png";
const TargetTrackingResults = (props) => {
  const { data } = props;
  const { addTargetTrackingScore } = useStorageActions();
  if (data) {
    let totalTargets = 0;
    let hits = 0;
    let time = data.targets[0] ? data.finishTime - data.targets[0].birth : 0;
    let accuracy = 0; // hits/totalTargets
    let precision = 0;
    let responseTime = 0;
    let speed = 0; // hits/time

    data.targets.forEach((target) => {
      if (target.birth < data.finishTime) {
        totalTargets++;
        if (target.isClicked) {
          hits++;
          responseTime = responseTime + target.clickedTime - target.birth;
          precision =
            precision +
            (target.clickR - target.pos.subtr(target.clickPos).mag()) /
              target.clickR;
        }
      }
    });

    responseTime = totalTargets === 0 ? 0 : responseTime / totalTargets;
    precision = hits === 0 ? 0 : (precision / hits) * 100;
    accuracy = totalTargets === 0 ? 0 : (hits / totalTargets) * 100;
    speed = time === 0 ? 0 : (hits / time) * 1000;

    return (
      <div
        style={{
          position: "absolute",
          width: props.width,
          height: props.height,
          // backgroundColor: "#FFFFFF26",
          color: "white",
          fontSize: "large",
          fontWeight: "700",
          zIndex: 2,
        }}
        className="d-flex mb-5 pb-5 flex-column justify-content-center align-items-center"
      >
        <img
          src={bgResult}
          alt="bgResult"
          style={{ position: "absolute" }}
        ></img>
        <div
          className="d-flex flex-column justify-content-start align-items-center text"
          style={{ width: 400, position: "absolute" }}
        >
          <div className="mt-3 pt-4" style={{ fontSize: "x-large" }}>
            Result
          </div>
          <div className="d-flex justify-content-between align-items-center mt-5 w-100 ">
            <span>Hits</span>
            <span>{hits}</span>
          </div>
          {/* <div className="d-flex justify-content-between align-items-center mt-1 w-100">
            <span>Miss</span>
            <span>{totalTargets - hits}</span>
          </div> */}
          <div className="d-flex justify-content-between align-items-center mt-1 w-100">
            <span>Accuracy</span>
            <span>N/A</span>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-1 w-100">
            <span>Precision</span>
            <span>{Math.round(precision * 100) / 100} %</span>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-1 w-100">
            <span>Avg response time</span>
            <span>{Math.round(responseTime * 1000) / 1000} ms</span>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-1 w-100">
            <span>Speed</span>
            <span>{Math.round(speed * 100) / 100} targets/sec</span>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-1 mb-3 w-100">
            <span>Time</span>
            <span>{time / 1000} sec</span>
          </div>
          <button
            onClick={props.startGame}
            className=" btn core-button py-1 px-1"
          >
            {/* <div className="d-flex  justify-content-center align-items-center">
              <RedoOutlined style={{ fontSize: 36 }} />
              <span className="ml-2">RESTART</span>
            </div> */}
            <img
              style={{ transform: "translateY(20%)" }}
              src={playAgain}
              onMouseOver={(e) => {
                e.currentTarget.src = playAgainHover;
              }}
              onMouseOut={(e) => {
                e.currentTarget.src = playAgain;
              }}
              alt="play"
            ></img>
          </button>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default TargetTrackingResults;
